import reducers from "./reducers";
import sagas from "./sagas";

export default {
    name: "checkin",
    reducers,
    sagas,
};
